module.exports = __webpack_public_path__ + "media/application/images/svgs/figma-7b5a7c61d952ede0746061eb80eeec7a.svg";